import { render, staticRenderFns } from "./ShopMenuItemService.vue?vue&type=template&id=66d13106&"
import script from "./ShopMenuItemService.vue?vue&type=script&lang=ts&"
export * from "./ShopMenuItemService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports